import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { switchMap, takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { Subject } from 'rxjs';
import { GlobalService, Login, ProgressoService, } from 'eddydata-lib';
import { LicitacaoAudespService } from 'compra-lib';

declare var $: any;

@Component({
  selector: 'lib-login-audesp',
  templateUrl: './login-audesp.component.html'
})
export class LoginAudespComponent implements OnInit, AfterViewInit, OnDestroy {

  protected login: Login;
  protected email: string = null;
  protected senha: string = null;
  public msgs: string;

  protected unsubscribe: Subject<void> = new Subject();
  @Output() conectado: EventEmitter<any> = new EventEmitter();

  constructor(
    private route: ActivatedRoute,
    protected messageService: MessageService,
    protected licitacaoAudespService: LicitacaoAudespService,
    protected progressoService: ProgressoService,
    public globalService: GlobalService,
  ) { }

  ngOnInit() {
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewInit() {
    this.globalService.calendarMascara();
  }

  async loginAudesp() {
    this.sessaoAudesp(true)
    if (!this.email?.trim() || !this.senha?.trim()) {
      this.msgs = 'Usuário/Senha não informados!'
      return;
    }
    this.msgs = null;
    this.licitacaoAudespService.loginAudesp(this.email, this.senha).pipe(takeUntil(this.unsubscribe)).subscribe((idTransacao) => {
      this.progressoService.show(idTransacao, async (retorno) => {
        if (retorno?.access_token?.length) {
          this.sessaoAudesp(false, retorno);
        }
        // GlobalService.salvarSessaoLogin(this.login);
        $('#dialogLoginAudesp').modal('hide');
      }, e => {
        this.msgs = e
        this.sessaoAudesp(true);
      })
    }, e => {
      this.msgs = e
      this.sessaoAudesp(true);
    });

  }

  sessaoAudesp(limpar: boolean, dados?: any) {
    if (limpar) {
      this.login.token_audesp = null;
      this.login.validade_audesp = null;
      this.login.token_type_audesp = null;
      this.conectado.emit(this.login);
    } else {
      this.login.token_audesp = dados.access_token;
      this.login.validade_audesp = dados.expire_in;
      this.login.token_type_audesp = dados.token_type;
      this.conectado.emit(this.login);
    }
    // GlobalService.salvarSessaoLogin(this.login);
  }

}
